import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './PackagesGridComponent.css';
import GlobalLoaderStore from '../../stores/GlobalLoaderStore';
import React from 'react';
import PackagesGridViewModel from '../../models/PackagesGrid/PackagesGridViewModel';
import PaginationComponent from '../providers/PagintationComponent';
import PackagesStore from '../../stores/PackagesStore';
import { RouterStore } from 'mobx-react-router';
import EligibilityDataStore from '../../stores/EligibilityDataStore';
import PackagesConstants from '../../constants/packagesConstants';
import DropdownComponent from '../common/inputs/DropdownComponent';
import CodeHelpers from '../../helpers/common/CodeHelpers';
import { InputWidthTypes } from '../../helpers/common/StyleHelper';
import EligibilityItem from './EligibilityItem'
import PackagesModel from '../../models/PackageDetails/PackageModel'
import { PACKAGES_NAME_CY_DATA, PACKAGES_FILTER_CY_DATA, PACKAGES_GRID_CY_DATA, PACKAGES_GRID_PAGINATION_CY_DATA } from '../../cypressDataConstants/packagesDetailsCyDataConstants';
import { CaughtException } from 'mobx/lib/internal';
import TextInputComponent from '../common/inputs/TextInputComponent';
import PackageQueryParameter from "../../models/TestSubscription/PackageQueryParameter";
import PackageConstants from '../../constants/packagesConstants';
import GraphQLHelper from '../../helpers/common/GraphQLHelper'
import { _allowStateChangesInsideComputed } from 'mobx';
import {  envTypeToString,  stringToEnvType } from '../../models/Organizations/OrganizationModel';

import { observable, action } from 'mobx';
import EligibilityConstants from '../../constants/eligibilityConstants';
export enum EnvironmentType{
    Production,
    Pilot,
    Stage,
    Load,
    Demo,
    QA
}

interface CourseEligibilityGridComponentProps {
    globalLoader?: GlobalLoaderStore,
    routing?: RouterStore,
    eligibilityStore: EligibilityDataStore,
}


interface CourseEligibilityGridComponentState {
    gcid: string,
    orgId: string,
    env: string,
    corp: string,
    key: number,
    hasError: boolean,
    gcidInputError: string,
    envDataMissingError: string,
    corpInputError: string,
    orgIdInputError: string,
    resultData: any
}

const fieldNames: string[] = ["BundleID", "CIID", "GlobalContentID", "PackageID", "ProviderID", "SubscriberUri"]


@inject('eligibilityStore','globalLoader', 'routing')
@observer
export default class CourseEligibilityGridComponent extends Component<CourseEligibilityGridComponentProps, CourseEligibilityGridComponentState> {
    constructor(props: CourseEligibilityGridComponentProps) {
        super(props);
            this.state = {
                hasError: false,
                gcid: "",
                orgId: "",
                corp: "",
                env: "",
                key: 0,
                gcidInputError: "",
                envDataMissingError:"",
                resultData: null
            }
        }

    componentDidMount() {
    }
    componentDidUpdate() {
      
    }
    
    onGcidChanged = (value: string) => {
        this.setState({gcid:value});
    }

    onEnvChanged = (value: string) => {
        this.setState({env:value});
    }
    
    onOrgIdChanged = (value: string) => {
        this.setState({orgId:value});
    }

    onCorpNameChanged = (value: string) => {
        this.setState({corp:value});
    }

    onSubmitClick = () => {
        if(!this.state.gcid){
            this.setState({gcidInputError:'GCID required and missing'});
            return;
        }
        else{
            this.setState({gcidInputError:''});
        }
        if((!this.state.env || !this.state.corp) && !this.state.orgId){
            this.setState({envDataMissingError:'Env + Corp OR Org Id required'});
            return;
        }
        else{
            this.setState({envDataMissingError:''});
        }

        // if (!this.state.queryValue) {  alert("Query value is invalid."); return;}
        // if (!this.isValidDate(this.state.startDate) || !this.isValidDate(this.state.endDate)) { alert("Date is invalid"); return }

        // let query: PackageQueryParameter = {
        //     QueryParameter: this.state.queryValue,
        //     QueryParameterColName: this.state.queryField,
        //     StartDate: this.state.startDate,
        //     EndDate: this.state.endDate
        // }
        this.props.globalLoader!.startLoading();
        GraphQLHelper.EvalCourseEligibility(this.state.corp,this.state.env, this.state.gcid, this.state.orgId).then(_data => {
            var res = this.mapResultsToEligibilityGridViewModelObject(_data);
            console.log("list:", res);
            this.setState({ resultData: res })
        }).catch(err => {
            console.log("Error!", err)
        }).finally(()=> this.props.globalLoader!.finishLoading());
    }
    mapResultsToEligibilityGridViewModelObject = (data: any) => {
        var result: any[] = []
        this.props.eligibilityStore.EligibilityData.ClientSubscribedBundles = data.ClientSubscribedBundles;
        this.props.eligibilityStore.EligibilityData.CourseBundles = data.CourseBundles;
        this.props.eligibilityStore.EligibilityData.Reason = data.Reason;
        this.props.eligibilityStore.EligibilityData.Status = data.Status;
        this.props.eligibilityStore.TotalPages = Math.ceil(this.props.eligibilityStore.EligibilityData.length / PackageConstants.ITEMS_PER_PAGE_COUNT);
        data.forEach(item => {
            result.push(new (item.Id, item.Name, item.IsForCuration, item.IsCreatedByCorp))
        });
        return result;
    }

    ResetCurrentSort = (idString: string) => {
        var elements = document.getElementsByClassName("sortable");
        while (elements.length)
            elements[0].classList.remove("sortable");

        var sortTarget = document.getElementById(idString);
        sortTarget?.classList.add("sortable");
    }
    
    renderGridHeaderItem = (title: string, onSort: (isDescending: boolean) => void) => {
        return <th scope='col'>
            <div className="csod-grid-header-container">
                {title}
                {onSort != null ? 
                    <div className="csod-sorting-container">
                        <div id={title + 'up'} className="csod-sort-up " onClick={() => {
                            onSort(true)
                            this.ResetCurrentSort(title + 'up')
                        }}><div className="csod-icon-sort-up">▲</div></div>
                        <div id={title + 'down'} className="csod-sort-down" onClick={() => {
                            onSort(false) 
                            this.ResetCurrentSort(title + 'down')
                        }}><div className="csod-icon-sort-down">▼</div></div>
                    </div> : null
                }
            </div>
        </th>
    }
    static getDerivedStateFromError(error: CaughtException) {
        return { hasError: true };
    }
      onStartDateChange = (event: string) => {
        if(event)
            this.setState({ startDate: event })
    }
    onEndDateChange = (event: string) => {
        if(event)
            this.setState({ endDate: event })
    }

    
    sortByBundleNameCourse = (isDescending: boolean) => {
       this.props.eligibilityStore.EligibilityData!.CourseBundles!.sort((a, b) => { return isDescending ? -(a.Name!.localeCompare(b.Name!)) : (a.Name!.localeCompare(b.Name!)) });
       this.setState({key: ++this.state.key});
    }

    sortByBundleIdCourse = (isDescending: boolean) => {
        this.props.eligibilityStore.EligibilityData!.CourseBundles!.sort((a, b) => { return isDescending ? -(a.Id!.localeCompare(b.Id!)) : (a.Id!.localeCompare(b.Id!)) });
        this.setState({key: ++this.state.key});

    }

    sortByBundleNameClient = (isDescending: boolean) => {
        this.props.eligibilityStore.EligibilityData!.ClientSubscribedBundles!.sort((a, b) => { return isDescending ? -(a.Name!.localeCompare(b.Name!)) : (a.Name!.localeCompare(b.Name!)) });
        this.setState({key: ++this.state.key});
        
    }

    sortByBundleIdClient = (isDescending: boolean) => {
        this.props.eligibilityStore.EligibilityData!.ClientSubscribedBundles!.sort((a, b) => { return isDescending ? -(a.Id!.localeCompare(b.Id!)) : (a.Id!.localeCompare(b.Id!)) });
        this.setState({key: ++this.state.key});
    }

    render() {
        if (this.props.globalLoader!.isLoading) {
            return null;
        }
        if (this.state.hasError) {
            return <h1>Something went wrong.</h1>;
        }

        return  <div className="csod-packages-container">
                    <div className="csod-search-container">
                        <div className="csod-packages-count-title">Course Eligibility</div>
                        <div className="csod-search-container-query">
                            <TextInputComponent title="GCID"
                                placeholder=""
                                widthClass={InputWidthTypes.Small}
                                defaultValue={this.state.gcid}
                                additionalClass='borderedComponent'
                                important={false}
                                onValueChanged={(e) => this.onGcidChanged(e)}
                            />

                            <DropdownComponent
                                    title="Environment"
                                    placeholder="Choose environment"
                                    items={[EnvironmentType[EnvironmentType.Production], EnvironmentType[EnvironmentType.Pilot],  EnvironmentType[EnvironmentType.Stage], EnvironmentType[EnvironmentType.Load],
                                        EnvironmentType[EnvironmentType.Demo], EnvironmentType[EnvironmentType.QA]]}
                                    widthClass={InputWidthTypes.Small}
                                    defaultValue={this.state.env}
                                    additionalClass='borderedComponent'
                                    onValueChanged={(e) => this.onEnvChanged(e)}
                                    important={true}
                            />
                                
                            <TextInputComponent title="Corp Name"
                                    placeholder="Enter corp name"
                                    widthClass={InputWidthTypes.Small}
                                    additionalClass='borderedComponent'
                                    defaultValue={this.state.corp}
                                    important={false}
                                    onValueChanged={(e) => this.onCorpNameChanged(e)}
                            />
                            <TextInputComponent title="Organization ID"
                                        placeholder="Specify org ID"
                                        widthClass={InputWidthTypes.Small}
                                        additionalClass='borderedComponent lastBorder'
                                        defaultValue={this.state.orgId}
                                        important={false}
                                        onValueChanged={(e) => this.onOrgIdChanged(e)}
                            />
                           
                            <div className="csod-inputs-column-container" style={{position:'relative', paddingBottom:'50px'}}>
                                <button type="button" style={{display:'inline-block'}} className="csod-button less-rounded-corners blue query-set-width" onClick={this.onSubmitClick}>Get Course Eligibility</button>
                                {!CodeHelpers.IsStringNullOrEmpty(this.state?.envDataMissingError) ? <div className="error-text-color customErrorStyle">{this.state.envDataMissingError}</div> : null} 
                                {!CodeHelpers.IsStringNullOrEmpty(this.state?.gcidInputError) ? <div className="error-text-color customErrorStyle">{this.state.gcidInputError}</div> : null} 

                            </div>
                        </div>
                            {this.props.eligibilityStore?.EligibilityData?.Reason != null && <div className='reasonStyle'>
                                {this.props.eligibilityStore?.EligibilityData?.Reason}
                            </div>
                            }

                        {this.props.eligibilityStore?.EligibilityData == null || this.props.eligibilityStore?.EligibilityData?.CourseBundles == undefined ||this.props.eligibilityStore?.EligibilityData?.CourseBundles.length == 0  ? '' :
                            <div>
                                <table className="csod-packages-grid" cy-data={PACKAGES_GRID_CY_DATA}>
                                    <thead>
                                        <tr>
                                            {this.renderGridHeaderItem(EligibilityConstants.GCID_RELATED_BUNDLE_NAME, this.sortByBundleNameCourse)}
                                            {this.renderGridHeaderItem(EligibilityConstants.GCID_RELATED_BUNDLE_ID, this.sortByBundleIdCourse)}
                                            {this.renderGridHeaderItem(EligibilityConstants.IS_FOR_CURATION, null)}
                                            {this.renderGridHeaderItem(EligibilityConstants.CREATED_BY_CORP, null)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        }
                                        {
                                            this.props.eligibilityStore?.EligibilityData?.CourseBundles?.map((item) => { return <EligibilityItem Package={item} key={item.Id} RedirectToUpdate={() => { }} /> })
                                        }
                                    </tbody>
                                </table>
                                <br/>
                                <br/>
                                <table className="csod-packages-grid" cy-data={PACKAGES_GRID_CY_DATA}>
                                    <thead>
                                        <tr>
                                            {this.renderGridHeaderItem(EligibilityConstants.CLIENT_OWNED_BUNDLE_NAME, this.sortByBundleNameClient)}
                                            {this.renderGridHeaderItem(EligibilityConstants.CLIENT_OWNED_BUNDLE_ID, this.sortByBundleIdClient)}
                                            {this.renderGridHeaderItem(EligibilityConstants.IS_FOR_CURATION, null)}
                                            {this.renderGridHeaderItem(EligibilityConstants.CREATED_BY_CORP, null)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        }
                                        {
                                            this.props.eligibilityStore?.EligibilityData?.ClientSubscribedBundles?.map((item) => { return <EligibilityItem Package={item} key={item.Id} RedirectToUpdate={() => { }} /> })
                                        }
                                    </tbody>
                                </table>
                                <br/>                                
                                <br/>
                            </div>
                        }
                    <br/>
                    <hr/>
                    </div>
                </div>
    }
}